export default __webpack_public_path__ + "static/media/vTrx.ddbd4bd1.svg";